import { useTheme } from '@mui/system'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import { Field, Form, Formik } from 'formik'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxRadioButton from 'components/custom/AdxRadioButton'
import { addDays, format } from 'date-fns'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import * as Yup from 'yup'
import { DEFAULT_ACTIVATE_ADS, jobAdValidation } from 'module/recruitment/utils/jobAdValidation'
import { Box, Icon, RadioGroup, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'

const ActivateJobAdsModal = ({ open, onClose, handleClose, mutate, isLoading }) => {
  const formSubmit = (e) => {
    mutate({ job_advertisement_duration: e })
  }

  const theme = useTheme()
  const horizontalButtonStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
    borderRadius: 0,
    height: theme.componentHeight.standard,
    width: '100%',
  }
  return (
    <AdxFormModal
      open={open}
      onClose={onClose}
      handleClose={handleClose}
      sxModal={{ width: '60%' }}
      title={'Activate Job Advertisement'}
    >
      <Formik
        enableReinitialize={true}
        validateOnBlur={false}
        initialValues={DEFAULT_ACTIVATE_ADS}
        validationSchema={Yup.object().shape(jobAdValidation)}
        // onSubmit={handleSubmit}
      >
        {({ values, touched, errors, handleChange, handleSubmit, setFieldValue }) => {
          const { job_advertisement_duration } = values

          return (
            <Form>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                }}
              >
                {/* Ads Duration */}
                <Typography variant="body1">
                  This job advertisement will be visible to jobseekers until it expires. You can
                  still deactivate this job advertisement anytime you want
                </Typography>
                <Box
                  display="flex"
                  alignItems="start"
                  justifyContent="start"
                  flexDirection="column"
                  gap={1}
                >
                  <Box display="flex">
                    <Typography variant="body1">Job duration</Typography>
                    <Typography variant="body1" color="error.main" sx={{ mb: 1 }}>
                      *
                    </Typography>
                  </Box>
                  <Field
                    as={RadioGroup}
                    name="job_advertisement_duration"
                    value={values.job_advertisement_duration}
                    sx={{
                      width: '100%',
                    }}
                  >
                    <Box
                      border={
                        touched.job_advertisement_duration &&
                        Boolean(errors.job_advertisement_duration)
                          ? 1
                          : 0
                      }
                      borderRadius="5px"
                      borderColor="red"
                      display="flex"
                      sx={{ width: '100%' }}
                    >
                      <AdxFormControlLabel
                        type="outlined"
                        control={<AdxRadioButton type="no-radio" />}
                        label="3 months"
                        value={90}
                        selected={parseInt(values.job_advertisement_duration)}
                        sx={{ ...horizontalButtonStyle, borderRadius: '5px 0 0 5px' }}
                      />
                      <AdxFormControlLabel
                        type="outlined"
                        control={<AdxRadioButton type="no-radio" />}
                        label="6 months"
                        value={180}
                        selected={parseInt(values.job_advertisement_duration)}
                        sx={horizontalButtonStyle}
                      />
                      <AdxFormControlLabel
                        type="outlined"
                        control={<AdxRadioButton type="no-radio" />}
                        label="9 months"
                        value={270}
                        selected={parseInt(values.job_advertisement_duration)}
                        sx={{ ...horizontalButtonStyle, borderRadius: '0 5px 5px 0' }}
                      />
                    </Box>
                    {errors.job_advertisement_duration ? (
                      <AdxErrorMessage>{errors.job_advertisement_duration}</AdxErrorMessage>
                    ) : null}
                  </Field>
                  <Box
                    bgcolor="default-background.main"
                    height={45}
                    display="flex"
                    alignItems="center"
                    sx={{
                      width: '100%',
                      borderRadius: '4.5px',
                      px: 2,
                      gap: 1,
                    }}
                  >
                    <Icon sx={{ color: 'light-gray-text.main' }}>calendar_month_icon</Icon>
                    <Typography
                      variant="body2"
                      display="flex"
                      alignItems="center"
                      color="light-gray-text.main"
                    >
                      Expires on:{' '}
                      {values.job_advertisement_duration
                        ? format(
                            addDays(new Date(), values.job_advertisement_duration),
                            'dd MMM yyyy'
                          )
                        : null}
                    </Typography>
                  </Box>
                </Box>
                <Box display="flex" gap={1} justifyContent="flex-end">
                  <AdxButton variant={'outlined'} size="standard" onClick={handleClose}>
                    Cancel
                  </AdxButton>
                  {isLoading ? (
                    <AdxButton
                      variant={'contained'}
                      size="standard"
                      sx={{
                        px: {
                          xs: 4,
                          sm: 12,
                        },
                        width: 200,
                      }}
                      isLoading
                    ></AdxButton>
                  ) : (
                    <AdxButton
                      variant={'contained'}
                      size="standard"
                      sx={{
                        px: {
                          xs: 4,
                          sm: 12,
                        },
                        width: 200,
                      }}
                      onClick={() => {
                        // setFormSubmitAttempt((prev) => prev + 1)
                        formSubmit(job_advertisement_duration)
                        // handleTypeOfForm("publish")
                      }}
                    >
                      Activate
                    </AdxButton>
                  )}
                </Box>
              </Box>
            </Form>
          )
        }}
      </Formik>
    </AdxFormModal>
  )
}
export default ActivateJobAdsModal
